var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileHoveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 64,
    viewBox: "0 0 57 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0714 0H39L57 18V59.9375C57 62.182 55.1761 64 52.9286 64H4.0714C1.8239 64 0 62.182 0 59.9375V4.06246C0 1.81801 1.82411 0 4.0714 0Z",
    fill: "#3F41EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 18H43.0129C40.7977 18 39 16.2041 39 13.9911V0L57 18Z",
    fill: "#2A2CD9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHoveredIcon);
export default __webpack_public_path__ + "static/media/file-hovered-icon.0d402f1a23a9ade9c5ff6d9332d78735.svg";
export { ForwardRef as ReactComponent };